export default "__VITE_ASSET__a8f28daa__"